import { __extends } from "tslib";
import { namespacedClassnames } from '../../common/namespace-classes';
import * as React from 'react';
var HeightAnimation = /** @class */ (function (_super) {
    __extends(HeightAnimation, _super);
    function HeightAnimation(props) {
        var _this = _super.call(this, props) || this;
        _this.contentElement = null;
        _this.animationDuration = _this.props.duration || 200;
        _this.state = {
            height: 'auto',
            overflow: 'visible'
        };
        _this.state.height = props.show ? 'auto' : '0';
        _this.state.overflow = props.show ? 'visible' : 'hidden';
        return _this;
    }
    HeightAnimation.prototype.componentDidMount = function () {
        if (React.Children.count(this.props.children) > 1) {
            // tslint:disable-next-line:max-line-length
            console.warn('HeightAnimation should have exactly one child. Make sure you have wrapped the content you want to animate.');
        }
    };
    HeightAnimation.prototype.componentWillReceiveProps = function (nextProps) {
        var props = this.props;
        if (!nextProps || nextProps.show === props.show) {
            return;
        }
        if (nextProps.animationDuration && nextProps.animationDuration !== this.animationDuration) {
            this.animationDuration = nextProps.animationDuration;
        }
        var shouldShow = nextProps.show;
        if (shouldShow) {
            this.handleShow();
        }
        else {
            this.handleHide();
        }
    };
    HeightAnimation.prototype.getFullContentHeight = function () {
        if (!this.contentElement) {
            return 0;
        }
        var elem = this.contentElement.firstElementChild;
        var styles = window.getComputedStyle(elem);
        var margin = parseInt(styles.marginTop || '', 10) + parseInt(styles.marginBottom || '', 10);
        return Math.ceil(elem.offsetHeight + margin);
    };
    HeightAnimation.prototype.handleShow = function () {
        var _this = this;
        var contentHeight = this.getFullContentHeight();
        var endHeight = contentHeight;
        this.setState({ height: endHeight });
        setTimeout(function () {
            _this.setState({ height: 'auto', overflow: 'visible' });
        }, this.animationDuration);
    };
    HeightAnimation.prototype.handleHide = function () {
        var _this = this;
        var startHeight = this.getFullContentHeight();
        var endHeight = 0;
        this.setState({ height: startHeight, overflow: 'hidden' });
        setTimeout(function () {
            _this.setState({ height: endHeight });
        }, 0);
    };
    HeightAnimation.prototype.setContentNode = function (e) {
        if (e) {
            this.contentElement = e;
        }
    };
    HeightAnimation.prototype.render = function () {
        var props = this.props;
        var animationClass = 'height';
        var showOrHide = props.show ? 'show' : 'hide';
        var classNames = namespacedClassnames(animationClass, showOrHide, props.className);
        var handleContentRef = this.setContentNode.bind(this);
        var heightStyle = {
            height: this.state.height,
            overflow: this.state.overflow,
            transition: "height " + this.animationDuration + "ms ease-in-out",
        };
        return (React.createElement("div", { className: classNames, style: heightStyle },
            React.createElement("div", { ref: handleContentRef, className: 'height-animation-content' }, props.children)));
    };
    return HeightAnimation;
}(React.Component));
export { HeightAnimation };
//# sourceMappingURL=height.js.map